"use client"

import { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { addContentTypesThunk } from 'features/common/model/slice/appSlice'
import { fetchSystemFieldsThunk } from 'features/assets/model/slice/assetsSlice'
import { fetchPackagesThunk } from 'features/team/model/slice/teamSlice'

import { fetchUserDataThunk } from '../model/slice/userSlice'
import { userSelector } from '../model/selectors/userSelectors'
export const UserInitializer = () => {
  const dispatch = useAppDispatch()
  const token = useAppSelector(state => state.user.token)
  const user = useAppSelector(userSelector)

  useEffect(() => {
    if (token) {
      dispatch(fetchUserDataThunk())
      // dispatch(addContentTypesThunk())
    }
  }, [])

  useEffect(() => {
    if (user?.family_user_id) {
      dispatch(fetchPackagesThunk())
    }
  }, [user?.family_user_id])

  useEffect(() => {
    if (user?.family_user_id) {
      dispatch(fetchSystemFieldsThunk())
    }
  }, [user?.family_user_id])

  return null
}
